import { BlockTitle } from "@blocks/Blocks";
import LeadCard from "@pages/Global/components/LeadCard";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { SanitizedSectionArticle } from "@typings/Cue";
import { sectionNavigationItems } from "@util/constant";
import { cn } from "@util/helpers";

type AseanSectionProps = {
  /** The articles to be displayed in the section */
  articles: SanitizedSectionArticle[];
  /** Optional className for the section */
  className?: string;
  /** Optional link params */
  linkParams?: URLSearchParams;
};

/**
 * AseanSection component to display a list of articles related to ;/internation/asean and /keywords/asia-pacific.
 * It renders a section with a title and a list of articles as LeadCard components.
 */
const AseanSection = ({
  articles,
  className,
  linkParams,
}: AseanSectionProps): React.ReactElement => {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const sectionData = {
    ...sectionNavigationItems["international/asean"],
  };

  if (!articles.length) return <></>;

  return (
    <section data-testid="global-asean-section-component" className={className}>
      <BlockTitle
        link={sectionData.link}
        text={sectionData.label.toUpperCase()}
      />

      <div className={cn("relative mb-6 w-full gap-6 lg:grid lg:grid-cols-3")}>
        {articles.map((article, index) => {
          return (
            <LeadCard
              key={index}
              article={article}
              displayBlurb
              displayEdited={false}
              displayUpdated
              displaySection={false}
              className="mb-7 mt-3 block w-full lg:mb-0"
              linkParams={linkParams}
              disablePaywall={
                OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER
              }
            />
          );
        })}
      </div>
    </section>
  );
};

export default AseanSection;
